module.exports = __webpack_public_path__ + "assets/img/warrior-name-7d562441.png";